<ng-container *ngIf="!!project.archived_at">
  <div class="bg-yellow-100 border-t border-b border-yellow-500 text-yellow-700 px-4 py-3" role="alert">
    <strong class="font-bold"
      >This deal was archived at {{ project.archived_at | date }} {{ project.archived_at | date: 'shortTime' }}
    </strong>
  </div>
</ng-container>
<div class="flex flex-auto justify-between">
  <projects-header-menu
    [currentTabId]="currentTabId"
    [projectRoute]="projectRoute"
    [editMode]="editMode"
    [project]="project"
    [account]="account"
    [dashboardDef]="projectTemplate?.definition?.dashboard"
    [userRole]="userRole"
    (onTabOrderChanged)="onTabOrderChanged($event)"
    (onTabAdded)="onTabAdded($event)"
    (onTabRemoved)="onTabRemoved($event)"
    (onTabTitleEdit)="onTabTitleEdit($event)"
    (onTabDuplicated)="onTabDuplicated($event)"
  >
  </projects-header-menu>
  <div class="flex flex-row items-center px-4">
    @if (!editMode) {
      <ts-button
        type="stroked"
        color="accent"
        (click)="toggleEditMode($event, undefined)"
        [appAuthorize]="authorizeEditLayout()"
        denyAction="disable"
      >
        <ts-icon [icon]="'edit'"></ts-icon>
        Edit Layout
      </ts-button>
      @if (!removeExportTabToPdfOnOverviewTab()) {
        <ts-button
          type="icon"
          icon="more_vert"
          color="accent"
          class="more-menu ml-2"
          [matMenuTriggerFor]="dealTabOptions"
          [appAuthorize]="newPermission.DEALS_SHARING_RECORDS"
        ></ts-button>
        <mat-menu #dealTabOptions="matMenu">
          <button
            DebounceClick
            (debounceClick)="exportAsPdf()"
            mat-menu-item
            [disabled]="exportingTabAsPdf"
            [appAuthorize]="newPermission.DEALS_SHARING_RECORDS"
          >
            @if (!exportingTabAsPdf) {
              <mat-icon class="icon-size-20 mr-2" [svgIcon]="'picture_as_pdf'"></mat-icon>
            } @else {
              <mat-progress-spinner class="mr-2" [diameter]="18" [mode]="'indeterminate'"></mat-progress-spinner>
            }
            Export tab as PDF
          </button>
        </mat-menu>
      }
    } @else {
      <ts-button class="pr-2" type="flat" color="warn" (click)="toggleEditMode($event, true)">
        <ts-icon [icon]="'close'"></ts-icon>
        Cancel
      </ts-button>
      <ts-button type="flat" color="success" (click)="toggleEditMode($event, false)">
        <ts-icon [icon]="'save'"></ts-icon>
        Save
      </ts-button>
    }
  </div>
</div>
